'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.dayFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/dayFromNow.js
// module id = 662
// module chunks = 0